class BrandStoreLocator extends HTMLElement
{

    connectedCallback()
    {
        this.swiper = new Swiper(this, {
            slidesPerView: 'auto',
            spaceBetween : 0,
            loop: true,
            speed: 6000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            }
        });
    }

    disconnectedCallback()
    {
        this.swiper?.destroy();
    }
}

customElements.define('brand-store-locator', BrandStoreLocator)